/**
 * Un raccourci de rubrique n'est pas une navigation : garder l'URL, l'historique et le shell
 * connectés intacts. Les liens href="#…" peuvent déclencher popstate et remonter l'application.
 * Voir docs/ui-navigation.md ; les vrais parcours et le retour OAuth restent distincts.
 */
export function scrollToSection(id: string): void {
  document.getElementById(id)?.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    block: 'start',
  });
}
